import { render, staticRenderFns } from "./TreatmentData.vue?vue&type=template&id=9620c388&scoped=true"
import script from "./TreatmentData.vue?vue&type=script&lang=ts"
export * from "./TreatmentData.vue?vue&type=script&lang=ts"
import style0 from "./TreatmentData.vue?vue&type=style&index=0&id=9620c388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9620c388",
  null
  
)

export default component.exports